import { API_ROOT } from 'src/constants';
import Request, { setData, setMethod, setURL } from 'src/services';
import { User } from 'src/types/Account';

import {
  ResetPasswordSchema,
  updateAccountSchema
} from './account.schema';
import { getNamespaceName } from 'src/services/objects/namespaces';
import { Account } from 'src/types/Account';

/**
 * getAccountInfo
 *
 * Return account information,
 * including contact and billing info.
 *
 */
export const getAccountInfo = (id: any) =>
  Request<Account>(setURL(`${API_ROOT}/accounts/${id}`), setMethod('GET')).then(
    (response) => response.data
  );

/**
 * getAccountInfo
 *
 * Return account information,
 * including contact and billing info.
 *
 */
export const getAllUsers = (params: any) =>
  Request<any>(
    setURL(`${API_ROOT}/${getNamespaceName()}/accounts/all`),
    setMethod('POST'),
    setData(params)
  ).then((response) => response.data);

/**
 * updateAccountInfo
 *
 * Update your contact or billing information.
 *
 */
export const updateAccountInfo = (data: any) => Request<Account>(
  setURL(`${API_ROOT}/accounts/${data.id}`),
  setMethod('PUT'),
  setData(data, updateAccountSchema)
).then((response) => response.data);

/**
 * resetPassword 
 * To reset your password using the token sent via the forgot password email, 
 * which is provided by the API after submitting a forgot password request.
*/
export const resetPassword = (data: Partial<any>) =>
  Request<User>(
    setURL(
      `${API_ROOT}/${getNamespaceName()}/reset_password`
    ),
    setMethod('PUT'),
    setData(data, ResetPasswordSchema)
  ).then((response) => response.data);



/**
 * updateJustPassword
 *
 * Updates the password in the account.
 *
 * @param data { object } The new password
 *
 * Note: Here we just send the new password only. If you notice the URL is prefixed with /u
 * There is no need to send the old password in the account update
 * The old password is encrypted and stored and cant be decrypted.
 */
export const updateJustPassword = (data: any) =>
  Request<Account>(
    setURL(`${API_ROOT}/accounts/u/${data.id}/password`),
    setMethod('PUT'),
    setData(data, ResetPasswordSchema)
  ).then((response) => response.data);


/**
 * updateMyPassword
 *
 * Updates the password of login account.
 *
 * @param data { object } The new password
 *
 * Note: Here we just send the new password only. with Cookie jwt it will get account id.
 * There is no need to send the old password in the account update
 * The old password is encrypted and stored and cant be decrypted.
 */
export const updateMyPassword = (data: any) =>
  Request<Account>(
    setURL(`${API_ROOT}/accounts/password`),
    setMethod('PUT'),
    setData(data, ResetPasswordSchema)
  ).then((response) => {
    return response.data
  });



export const accountLogout = (data: any) =>
  Request<Account>(
    setURL(`${API_ROOT}/logout`),
    setMethod('POST'),
    setData(data)
  ).then((response) => response.data);